import { OverviewScore } from "@sabyr-dev/mist_core/model/datasource/score";
import { Attempt, Quiz } from "@sabyr-dev/mist_elibrary/datasource";
import { ElibrarySectionFrontend } from "@sabyr-dev/mist_elibrary/frontend";
import { getProductId } from "../../model/datasource/academy";

export class AcademySectionFrontend extends ElibrarySectionFrontend {
	displayHighScores(scores: OverviewScore<Attempt, Quiz>[]): void {
		const quizzes = Array.from(document.querySelectorAll<HTMLElement>('.test-score[data-quiz]'));
		for (const quiz of quizzes) {
			const score = scores.find(score =>
				this.quizIdSerializer.toString(score.quiz) == quiz.dataset.quiz
			);
			const complete = quiz.querySelector<HTMLLinkElement>('a.complete');
			const notComplete = quiz.querySelector('.not-complete');
			if (score) {
				const scoreDisplay = quiz.querySelector('.test-score');
				complete.href = `/practicequestion/result/${getProductId()}/${score.data.id}`;
				scoreDisplay.innerHTML = `${score.data.correct_count} / ${score.data.total_count}`;
				complete.classList.toggle('d-none', false);
				complete.classList.toggle('d-flex', true);
				notComplete.classList.toggle('d-none', true);
			} else {
				complete.classList.toggle('d-none', true);
				complete.classList.toggle('d-flex', false);
				notComplete.classList.toggle('d-none', false);
			}
		}
		for (const score of scores) {
			const testScore = document.querySelector<HTMLElement>(
				`.test-score[data-quiz="${this.quizIdSerializer.toString(score.quiz)}"] .test-score`
			);
			if (testScore) {
				testScore.innerText = `${score.data.correct_count} / ${score.data.total_count}`;
			}
		}
	}
}
